import { render } from "./AbsolutelyVideoPlayer.vue?vue&type=template&id=2c4c7f91&scoped=true"
import script from "./AbsolutelyVideoPlayer.vue?vue&type=script&lang=js"
export * from "./AbsolutelyVideoPlayer.vue?vue&type=script&lang=js"

import "./AbsolutelyVideoPlayer.vue?vue&type=style&index=0&id=2c4c7f91&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4c7f91"]])

export default __exports__